import { render, staticRenderFns } from "./ManageButtonsFooter.vue.js?vue&type=template&id=b3f6108e!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageButtonsFooter.vue?vue&type=template&id=b3f6108e"
import script from "./ManageButtonsFooter.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageButtonsFooter.vue?vue&type=script&lang=js"
export * from "./ManageButtonsFooter.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageButtonsFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports